<template>
  <div>
    <v-form v-model="valid" class="d-flex align-center" style="height: 95vh">
      <v-container>
          <h1>{{ $t('resetPassword') }}</h1>
        <h3>{{ $t('youLostYourPassword') }}</h3>
        <br>
        <v-row>
          <v-col cols="4">
            <v-text-field label="Email" outlined :rules="emailRule" v-model="email"/>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn :disabled="!valid" @click="resetPassword">{{ $t('sendRequest') }}</v-btn>
            <br>
            <br>
            <p v-html="$t('youRememberYourPassword')"></p>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-dialog v-model="sentRequest" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t('emailSent') }}
        </v-card-title>
        <v-card-text>
          {{ $t('resetePasswordRequest') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="goToLogin">{{ $t('okGoToLogin') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Repository from '../../../repositories/auth';

export default {
  name: "ResetPassword",
  data() {
    return {
      sentRequest: false,
      valid: false,
      email: '',
      emailRule: [
        e => !!e || this.$t('emailRule1'),
        e => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e) || this.$t('emailRule2'),
      ]
    };
  },
  methods: {
    resetPassword() {
      if (this.valid) {
        Repository.resetPassword(this.email);
        this.sentRequest = true;
      }
    },
    goToLogin() {
      this.sentRequest = false;
      this.$router.push('/');
    },
  },
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "resetPassword": "Reset your password",
    "youLostYourPassword": "You lost your password and we need your email to send a link and reset it.",
    "sendRequest": "Send Request",
    "youRememberYourPassword": "You remember your password, <a href='https://app.swiset.com/'>click here</a> to login.",
    "emailRule1": "Email is required",
    "emailRule2": "Invalid email",
    "emailSent": "Email Sent",
    "resetePasswordRequest": "Resete password request was sent",
    "okGoToLogin": "Ok, go to login"
  },
  "es": {
    "resetPassword": "Recupera tu contraseña",
    "youLostYourPassword": "Perdiste tu contraseña y necesitamos tu email para poder enviarte un link que te ayudara a recuperarla",
    "sendRequest": "Enviar petición",
    "youRememberYourPassword": "Recordaste tu contraseña, <a href='https://app.swiset.com/'>dale click aquí</a> para ingresar.",
    "emailRule1": "El email es obligatorio",
    "emailRule2": "El email es invalido",
    "emailSent": "El email fue enviado",
    "resetePasswordRequest": "Solicitud de recuperación de contraseña fue enviada",
    "okGoToLogin": "Ok, ingresar a Swiset"
  }
}
</i18n>